export const EXTERNAL_SCRIPT_TYPES = {
  STYLESHEET: 'stylesheet',
  JAVASCRIPT: 'javascript',
}

export const EXTERNAL_SCRIPT_LOAD_TYPES = {
  NONE: '',
  DEFER: 'defer',
  ASYNC: 'async',
}

export const EXTERNAL_SCRIPT_CROSSORIGIN_TYPES = {
  NONE: '',
  ANONYMOUS: 'anonymous',
  CREDENTIALS: 'credentials',
}
